import React from 'react';
import { Grid, Typography } from '@mui/material';
import colors from 'lib/themes/colors.module.scss';

type Props = any;
const WarningMessage: React.FC<Props> = (props: Props): JSX.Element => {
  const { message } = props;
  return (
    <Grid
      container
      item
      xs={12}
      style={{
        display: 'flex',
        color: colors.lightRed,
        fontWeight: '500',
        fontSize: '13px',
        padding: '20px',
        backgroundColor: `${colors.lightRed}22`,
        marginTop: '10px',
      }}
      justifyContent="flex-end"
    >
      {message}
    </Grid>
  );
};

export default WarningMessage;
